import { Flex, Stack, Title } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, NoContentPlaceholder, NumberFilter, useNumberFilter } from '@/core/components';

import { FilterBox } from '@feature/utils';

import { MobilityCard } from './components/Card/MobilityCard';
import { getMobilityListOptions } from './model/MobilityQuery';

export function MobilityPage() {
  const { t } = useTranslation();
  const { item: year, ...yearFilterProps } = useNumberFilter();
  const { data } = useSuspenseQuery(getMobilityListOptions(year ?? undefined));

  return (
    <Stack>
      <Flex
        justify="space-between"
        align="center"
      >
        <Title size="1.4rem">{t('mobilities.title')}</Title>
        <AddButtonLink name={t('mobilities.add')} />
      </Flex>

      <FilterBox>
        <NumberFilter
          label={t('mobilities.filters.year')}
          allowDecimal={false}
          min={1997}
          {...yearFilterProps}
          flex={0.25}
        />
      </FilterBox>

      {data.length === 0 ? (
        <NoContentPlaceholder title={t('mobilities.empty')} />
      ) : (
        <Stack>
          {data.map(mobility => (
            <MobilityCard
              key={mobility.id}
              mobility={mobility}
              to={`${mobility.id}`}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
